import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/icons/icon-floorplan.webp'
import _imports_1 from '@/assets/icons/icon-expand.svg'
import _imports_2 from '@/assets/icons/icon-close-dark.svg'
import _imports_3 from '@/assets/icons/oven-icon-black.png'
import _imports_4 from '@/assets/icons/bathtub-icon-black.png'
import _imports_5 from '@/assets/icons/sofa-icon-black.png'


const _hoisted_1 = {
  key: 0,
  class: "house-slider-options"
}
const _hoisted_2 = {
  key: 1,
  class: "content-logo-slider"
}
const _hoisted_3 = { class: "content-logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content-slider" }
const _hoisted_6 = {
  key: 0,
  class: "content-house-design-features"
}
const _hoisted_7 = { class: "content-house-design" }
const _hoisted_8 = { class: "title-house-design" }
const _hoisted_9 = { class: "content-features" }
const _hoisted_10 = { class: "content-carousel" }
const _hoisted_11 = {
  key: 1,
  class: "content-floorplan-builder-quote"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 3,
  class: "controls-color-desktop"
}
const _hoisted_14 = { class: "controls-colors" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text-exit-interiors" }
const _hoisted_17 = {
  key: 0,
  class: "text-jump-to"
}
const _hoisted_18 = { class: "content-jump-to-bottom" }
const _hoisted_19 = { class: "content-bottons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-wr", { isBuilderQuoteView: $props.isBuilderQuoteView }])
  }, [
    (!$setup.isDesktop && $setup.props.selectedBuilder && !$props.isBuilderQuoteView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["BuilderSliderButtons"], {
            class: "builder-slider-buttons",
            items: $setup.selectedBuilder.houses,
            selectedItem: $props.selectedHouseDesign ?? null,
            title: $setup.isDesktop ? 'Step 03 : ' : '',
            contentTitle: $setup.isDesktop ? 'Select Design' : 'Swipe to compare designs',
            isLogoSwipe: true,
            isHouseSelectSlider: true,
            onOnSelectItem: $setup.onSelectHouseDesign
          }, null, 8, ["items", "selectedItem", "title", "contentTitle"])
        ]))
      : _createCommentVNode("", true),
    ($setup.isDesktop && $setup.props.selectedBuilder && !$props.isBuilderQuoteView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            ($setup.selectedBuilder)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "builder-logo",
                  src: $setup.selectedBuilder.logo
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["BuilderSliderImages"], {
              images: $setup.selectedBuilder.houses,
              selectedimage: $props.selectedHouseDesign,
              isSelectDesign: true,
              onOnSelectImage: $setup.onSelectHouseDesign
            }, null, 8, ["images", "selectedimage"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["content-design-selections", { 'size-content': $props.isBuilderQuoteView }])
    }, [
      (!$setup.isDesktop && !$props.isBuilderQuoteView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString($props.selectedHouseDesign?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode($setup["HouseFeatures"], {
                features: $props.selectedHouseDesign ?? $setup.house,
                class: _normalizeClass($setup.isDesktop ? 'house-features' : 'house-features-mobile')
              }, null, 8, ["features", "class"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        (!$setup.showFloorplan)
          ? (_openBlock(), _createBlock($setup["CustomizeHouseSlider"], {
              key: 0,
              showArrows: false,
              sliderImages: $setup.sliderImages,
              isBuilderQuoteView: $setup.props.isBuilderQuoteView
            }, null, 8, ["sliderImages", "isBuilderQuoteView"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("img", {
                class: "floorplan-image",
                src: $props.selectedHouseDesign?.floorplans[0].url
              }, null, 8, _hoisted_12)
            ])),
        ($setup.isDesktop && $props.isBuilderQuoteView && $setup.currentSliderStep === $setup.BuilderSliderSteps.MAIN_IMAGE && !$setup.showFloorplan)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "jump-floorplan",
              onClick: $setup.onChangeImage
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "text-floorplan" }, "Floor Plan", -1),
              _createElementVNode("img", {
                class: "floorplan-svg",
                src: _imports_0
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        ($setup.showColorsControls && $setup.isDesktop && !$setup.showFloorplan)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "Compare colours", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "line-separator" }, null, -1)),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getColorsSelection, (item) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: "select-color",
                    style: _normalizeStyle({ 'background-color': item?.color }),
                    onClick: ($event: any) => ($setup.onSelectColor(item))
                  }, null, 12, _hoisted_15))
                }), 256))
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.showFloorplan && $props.isBuilderQuoteView)
          ? (_openBlock(), _createElementBlock("img", {
              key: 4,
              class: "icon-expand",
              src: _imports_1,
              onClick: $setup.openFloorplanImageModal
            }))
          : _createCommentVNode("", true),
        _createVNode($setup["BuilderLightboxImages"], {
          isOpen: $setup.isImageFloorplanModalOpen,
          imageUrl: $props.selectedHouseDesign?.floorplans[0]?.url,
          zoom: $setup.zoom,
          onUpdateZoom: $setup.updateZoom,
          onClose: $setup.closeImageModal
        }, null, 8, ["isOpen", "imageUrl", "zoom"]),
        (($setup.showExitInteriorsButton && $setup.sliderImages.length > 0) || ($setup.showFloorplan && $props.isBuilderQuoteView))
          ? (_openBlock(), _createElementBlock("div", {
              key: 5,
              class: "exit-interiors-container",
              onClick: $setup.exitInteriors
            }, [
              _createElementVNode("span", _hoisted_16, _toDisplayString($setup.showFloorplan ? "Close floor plan" : $setup.isDesktop ? "Exit Interiors" : "Hide Interiors"), 1),
              _cache[6] || (_cache[6] = _createElementVNode("img", {
                class: "logo-close",
                src: _imports_2
              }, null, -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!$setup.showFloorplan)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["content-jump-to-bottom-and-logo", { 'size-content': $props.isBuilderQuoteView }])
          }, [
            ($setup.showBrowseInteriorsText && $setup.isDesktop)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Browse Interiors"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                ($setup.isImageAvailable($setup.BuilderSliderSteps.KITCHEN))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["jump-button", { 'active-button': $setup.currentSliderStep === $setup.BuilderSliderSteps.KITCHEN }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.jumpToStep($setup.BuilderSliderSteps.KITCHEN)))
                    }, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-jump-to-button" }, "Kitchen", -1)),
                      ($setup.isDesktop)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: _normalizeClass(["small", { 'icon-white': $setup.currentSliderStep === $setup.BuilderSliderSteps.KITCHEN }]),
                            src: _imports_3
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                ($setup.isImageAvailable($setup.BuilderSliderSteps.BATHROOM))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["jump-button", { 'active-button': $setup.currentSliderStep === $setup.BuilderSliderSteps.BATHROOM }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.jumpToStep($setup.BuilderSliderSteps.BATHROOM)))
                    }, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-jump-to-button" }, "Bathroom", -1)),
                      ($setup.isDesktop)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: _normalizeClass(["small", { 'icon-white': $setup.currentSliderStep === $setup.BuilderSliderSteps.BATHROOM }]),
                            src: _imports_4
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                ($setup.isImageAvailable($setup.BuilderSliderSteps.LIVING))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["jump-button", { 'active-button': $setup.currentSliderStep === $setup.BuilderSliderSteps.LIVING }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.jumpToStep($setup.BuilderSliderSteps.LIVING)))
                    }, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-jump-to-button" }, "Living", -1)),
                      ($setup.isDesktop)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: _normalizeClass(["small", { 'icon-white': $setup.currentSliderStep === $setup.BuilderSliderSteps.LIVING }]),
                            src: _imports_5
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      ($setup.isDesktop && $setup.props.isBuilderQuoteView)
        ? (_openBlock(), _createBlock($setup["BuilderSelectFacade"], {
            key: 2,
            selectedHouseDesign: $setup.props.selectedHouseDesign,
            quote: $setup.props.quote,
            "onUpdate:selectedFacade": $setup.onUpdateSelectedFacade
          }, null, 8, ["selectedHouseDesign", "quote"]))
        : _createCommentVNode("", true),
      ($setup.isDesktop)
        ? (_openBlock(), _createBlock($setup["BuilderEstimatorHouseFeaturesDesktop"], {
            key: 3,
            currentFeature: $setup.currentFeature,
            house: $setup.house,
            class: _normalizeClass({ isBuilderQuoteView: $props.isBuilderQuoteView }),
            onSetCurrentFeature: $setup.setCurrentFeature
          }, null, 8, ["currentFeature", "house", "class"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}